export const MIXPANEL_USER_PROPERTY_KEYS = ['uuid', 'name', 'email', 'sign_up_source', 'sign_up_locale', 'has_api_access', 'created_at'];
export const MIXPANEL_DATA_PROPERTY_KEYS = ['has_subscription', 'has_enterprise_api_subscription', 'user_api_plan_type']

export const WHITELISTED_UTM_QUERY_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

export const ONE_OFF_TRACK_PAGEVIEW_ON_LOGIN = "one-off-track-pageview-on-login"

export const SELECT_SIGN_IN_CTA_EVENT = "select_sign_in_cta"
export const SELECT_SEARCH_CTA_EVENT = "select_search_cta"
export const SEARCH_EVENT = "search"
export const SELECT_SEARCH_EVENT = "select_search_result"
export const ANALYTICS_USER_LOGGED_IN = "analytics_user_logged_in"
export const SELECT_SEARCH_HIGHLIGHTS = "select_search_highlights"
export const SELECT_COIN_MAIN_TAB = "select_coin_main_tab"
export const SELECT_COIN_INFO = "select_coin_info"
export const VIEW_COIN_INSIGHTS = "view_coin_insights"
export const SELECT_COIN_SENTIMENT_VOTE_EVENT = "select_coin_sentiment_vote"
export const SELECT_COIN_CONTENT_FEEDBACK_EVENT = "select_coin_content_feedback"
export const VIEW_COIN_RECOMMENDATION = "view_coin_recommendation"
export const SELECT_ADD_PORTFOLIO_COIN_CTA_EVENT = "select_add_portfolio_coin_cta"
export const VIEW_PORTFOLIO_MODAL = "view_portfolio_modal"
export const SELECT_PORTFOLIO_VISUALIZATION_TOGGLE = "select_portfolio_visualization_toggle"
export const SELECT_PORTFOLIO_SUMMARY_CARD_TOGGLE = "select_portfolio_summary_card_toggle"
export const SELECT_API_SUBSCRIBE_CTA = "select_api_subscribe_cta"
export const SELECT_ADD_PORTFOLIO_NFT_CTA = "select_add_portfolio_nft_cta"
export const CHANGE_CATEGORY_HIGHLIGHT_TOGGLE = "change_category_highlight_toggle"
export const SELECT_AD_UNIT_EVENT = "select_ad_unit"
export const SELECT_FAST_PASS_CTA = "select_fast_pass_cta"
export const VIEW_CATEGORY_STATS = "view_category_stats"

export const SEARCH_EVENT_ORIGIN = {
  NAVBAR: "navbar",
  KEYBOARD_SHORTCUT: "keyboard_shortcut",
  STICKY_CTA: "sticky_cta",
};
